function TermMeedyVO(id, insurer, resource, patient, additionalRemarks, verificationCode, executionDate, type, eventName, status,
                     statusReason, statusDescription, allDay, begin, end, place, description, cyclic, cyclicTerm, idOrder,
                     patientFirstName, patientLastName, patientIdentifier, patientPhone, patientAddress, verified,
                     suite, suiteName, suitePrice, payer, fromMeedyDoctors, offersNames, price, payU, idIcrOrder) {

    this.id = id;
    this.insurer = insurer;
    this.resource = resource;
    this.patient = patient;
    this.additionalRemarks = additionalRemarks;
    this.verificationCode = verificationCode;
    this.executionDate = executionDate;
    this.type = type;
    this.eventName = eventName;
    this.status = status;
    this.statusReason = statusReason;
    this.statusDescription = statusDescription;
    this.allDay = allDay === true;
    this.begin = begin;
    this.end = end;
    this.place = place;
    this.description = description;
    this.cyclic = cyclic === true;
    this.cyclicTerm = cyclicTerm;
    this.idOrder = idOrder;
    this.patientFirstName = patientFirstName;
    this.patientLastName = patientLastName;
    this.patientIdentifier = patientIdentifier;
    this.patientPhone = patientPhone;
    this.patientAddress = patientAddress;
    this.verified = verified === true;
    this.suite = suite;
    this.suiteName = suiteName;
    this.suitePrice = suitePrice;
    this.payer = payer;
    this.fromMeedyDoctors = fromMeedyDoctors;
    this.offersNames = offersNames;
    this.price = price;
    this.payU = payU;
    this.idIcrOrder = idIcrOrder;


    var _typeContext = {
        cyclicTerm: CyclicTermMeedyVO,
        executionDate: Date,
        insurer : InsurerMeedyVO,
        resource : ResourceMeedyVO,
        patient : PatientMeedyVO,
        statusReason : StatusReasonVO,
        begin : Date,
        end : Date,
        suite : SuiteMeedyVO
    };

    this._getType = function(property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };

}

TermMeedyVO.prototype.getPrice = function () {
     if (this.insurer && (this.insurer.id === 219 || this.insurer.id === 221 || this.insurer.id === 267)) { // SignalIduna test/portal/cc
        return 0;
    } else {
        return this.price;
    }
};

TermMeedyVO.prototype.getPaymentMethodTranslateKey = function () {
    if(this.type=='CLAIM') {
        return 'T.MEEDY.MODULE.PATIENT.SUBSCRIPTION';
    }
    if (this.insurer && this.insurer.id==238) { //Only for Polmed ryczałt
        return 'T.MEEDY.MODULE.PATIENT.SUBSCRIPTION';
    } else if (this.insurer && (this.insurer.id === 219 || this.insurer.id === 221 || this.insurer.id === 267)) { // SignalIduna test/portal/cc
        return 'T.MEEDY.MODULE.PATIENT.SUBSCRIPTION';
    } else {
        return (this.payU) ? 'T.MEEDY.MODULE.PATIENT.PAYU' : 'T.MEEDY.MODULE.PATIENT.CASH';
    }
    return '';
};
